// Win milestones and frames (D-057, FigCraft "38 Win milestones"). Wins are rounds won by declaring DIGU at a table of
// people (practice and tables with computers don't count). Each milestone in the economy config pays its tokens once;
// milestones marked `frame` also give a frame for your picture, in this order of styles.
/** Frame styles in the order frame milestones give them: Liyelaa at the first (100 wins), Reed mat at the second (400). */
export const FRAME_STYLES = ["liyelaa", "reed"];
export const FRAME_NAMES = { liyelaa: "Liyelaa", reed: "Reed mat" };
export const isMilestoneFrame = (v) => typeof v === "string" && FRAME_STYLES.includes(v);
export const isOccasionFrame = (v) => typeof v === "string" && /^frame-occ-[a-z][a-z0-9-]{2,31}$/.test(v);
export const isFrameId = (v) => isMilestoneFrame(v) || isOccasionFrame(v);
/** A frame's name; an occasion frame's own name comes with its occasion, so this says "Occasion frame". */
export const frameName = (id) => (isMilestoneFrame(id) ? FRAME_NAMES[id] : "Occasion frame");
/** The frame a milestone gives: frame milestones take the styles in order; any beyond the last reuse it. */
export function milestoneFrame(milestones, wins) {
    const framed = [...milestones].filter((m) => m.frame).sort((a, b) => a.wins - b.wins);
    const i = framed.findIndex((m) => m.wins === wins);
    return i < 0 ? null : FRAME_STYLES[Math.min(i, FRAME_STYLES.length - 1)];
}
//# sourceMappingURL=milestones.js.map